const globalConfig = {
	footer: {
		display: false
	}
}

export default globalConfig
